import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    axiosLoading: false,
    userInfo: JSON.parse(sessionStorage.getItem('USER_INFO')) || {},
  },
  getters: {
    //提供全局的loading状态
    getAxiosLoading(state) {
      return state.axiosLoading
    },
    getUserInfo(state) {
      return state.userInfo
    },
  },
  mutations: {
    //axios请求的全局loadling
    showLoading(state) {
      state.axiosLoading = true
    },
    hideLoading(state) {
      state.axiosLoading = false
    },

    //设置用户信息
    setUserInfo(state, data) {
      state.userInfo = data
      console.log(data, '用户信息')
      sessionStorage.setItem('USER_INFO', JSON.stringify(data))
    },
    removeUserInfo(state) {
      state.userInfo = {}
      console.log(state.userInfo, '移除用户信息')

      sessionStorage.removeItem('USER_INFO')
    },
  },
  actions: {},
  modules: {},
})
